export type GroupSelectWithRegionsTranslation = {
  chosen: string;
  regions: string;
  selectedAllRegions: string;
};

export const groupSelectWithRegionsTranslation: GroupSelectWithRegionsTranslation = {
  chosen: 'Selected',
  regions: 'Regions',
  selectedAllRegions: 'All regions selected',
};
